import { MessageBox } from "element-ui";

const LOCAL_VERSION = process.env.VUE_APP_VERSION;
let checking = false;
// 本次会话已提示过（用户取消后不再反复弹）
let promptedInSession = false;

/**
 * 拉取远端 version.json（带时间戳，避免缓存）
 * 旧包没有该文件 / 请求失败时静默跳过，不当成版本不一致
 */
async function fetchRemoteVersion() {
  const base = process.env.BASE_URL || "/";
  const url = `${base}version.json?t=${Date.now()}`;
  const res = await fetch(url, {
    method: "GET",
    cache: "no-store",
    headers: {
      "Cache-Control": "no-cache",
      Pragma: "no-cache",
    },
  });
  if (!res.ok) {
    return null;
  }
  const data = await res.json();
  return data && data.version ? data.version : null;
}

/** 清理缓存后强制刷新到最新入口 */
async function forceRefresh(remoteVersion) {
  try {
    if ("caches" in window) {
      const keys = await caches.keys();
      await Promise.all(keys.map((key) => caches.delete(key)));
    }
    if (navigator.serviceWorker) {
      const regs = await navigator.serviceWorker.getRegistrations();
      await Promise.all(regs.map((reg) => reg.unregister()));
    }
  } catch (e) {
    // 清理失败仍继续刷新
  }
  const url = new URL(window.location.href);
  url.searchParams.set("_v", remoteVersion || Date.now());
  window.location.replace(url.toString());
}

/**
 * 比对本地打包版本与远端 version.json
 */
export async function checkAppVersion() {
  // 未注入版本号时不检测（异常构建）
  if (!LOCAL_VERSION) {
    return;
  }
  if (checking || promptedInSession) {
    return;
  }
  checking = true;
  try {
    const remoteVersion = await fetchRemoteVersion();
    // 无 json / 旧部署 / 网络异常：静默跳过
    if (!remoteVersion) {
      return;
    }
    if (remoteVersion === LOCAL_VERSION) {
      return;
    }
    promptedInSession = true;
    await MessageBox.confirm(
      "检测到系统已更新，请刷新页面以使用最新版本。",
      "版本更新提示",
      {
        confirmButtonText: "立即刷新",
        cancelButtonText: "稍后",
        type: "warning",
        closeOnClickModal: false,
        distinguishCancelAndClose: true,
      }
    );
    await forceRefresh(remoteVersion);
  } catch (e) {
    // 用户取消、请求失败等：不打断业务
  } finally {
    checking = false;
  }
}

/** 页面重新可见时检测（长驻标签页发版） */
export function setupVersionVisibilityCheck() {
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "visible") {
      checkAppVersion();
    }
  });
}
